var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { StudentDocument, } from '@/models/StudentDocument';
import { StudentDocumentStatus } from '@/models/StudentDocumentStatus';
import { DocumentableType, StudentDocumentTemplate, StudentDocumentTemplateIncludes, } from '@/models/StudentDocumentTemplate';
import { Teacher } from '@/models/Teacher';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AsyncSelect from '@/components/async-select/AsyncSelect.vue';
import ErrorHandler from '@/support/ErrorHandler';
import SelectFilter from '@/components/select-filter/SelectFilter';
import PlanTemplateRow from '@/components/PlanTemplateRow/PlanTemplateRow';
import Draggable from '@/components/Draggable/Draggable';
import MediaComponent from '@/components/Media/Media';
import SelectStudentLevelsDialog from '@/views/Users/Student/Dialogs/CreatePlanDialog/SelectStudentLevelsDialog/SelectStudentLevelsDialog.vue';
import CurriculumSelectDialog from '@/components/CurriculumSelectDialog/CurriculumSelectDialog';
import ActionDialogLayout from '@/views/Groups/Tabs/Actions/Dialogs/ActionDialogLayout/ActionDialogLayout.vue';
import { Lvs } from '@/models/Lvs';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import { sortByKey } from '@/support/Object';
import { debounce, sortBy } from 'lodash';
import AQuillEditor, { AQuillEditorActionsEnum } from '@/components/AQuillEditor/AQuillEditor.vue';
import AddCurriculumToDocumentDialog from '@/components/AddCurriculumToDocumentDialog/AddCurriculumToDocumentDialog.vue';
import Curriculum from '@/components/curriculum/Curriculum.vue';
import { RolesEnum } from '@/items/Roles';
import { generatePlanPayload } from '@/support/GeneratePlanPayload';
let AddDocumentDialog = class AddDocumentDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isValidFirstStep = false;
        this.planCopy = new StudentDocument();
        this.isEditingStartDate = false;
        this.isEditingEndDate = false;
        this.isAddingStep = false;
        this.planStatuses = [];
        this.isLoadingPlanStatuses = true;
        this.studentLvs = [];
        this.isLoadingLvs = true;
        this.planTemplates = [];
        this.isLoadingPlanTemplates = true;
        this.teacherModel = new Teacher();
        this.internalSelectedTeachers = [];
        this.currentStep = 1;
        this.isLoading = true;
        this.draggableBlockItems = [];
        this.curriculum = new CurriculumModel();
        this.isLoadingUserCurriculum = true;
        this.selectedTemplate = null;
        this.isCurriculumSelectDialogOpen = false;
        this.blockCounter = 0;
        this.isInitialized = false;
        this.isSaving = false;
        this.savedDocumentId = undefined;
        this.debouncedAutosave = debounce(this.autosave, 3000, { maxWait: 10000 });
        this.AQuillEditorActionsEnum = AQuillEditorActionsEnum;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    beforeDestroy() {
        if (this.isInitialized) {
            this.debouncedAutosave.flush();
        }
        this.cancelDebouncedPayload();
    }
    async initialize() {
        this.isLoading = true;
        if (this.document) {
            this.planCopy = this.document;
            this.savedDocumentId = this.document.id || undefined;
            if (this.planCopy.is_editable_for_teachers && this.planCopy.is_visible_for_teachers) {
                this.planCopy.is_visible_for_teachers = false;
            }
        }
        await Promise.all([
            this.fetchPlanTemplates(),
            this.fetchPlanStatuses(),
            this.fetchCurriculum(),
        ]);
        if (!this.planCopy.blocks || !this.planCopy.blocks.length) {
            this.planCopy.blocks = [];
            this.appendBlock();
        }
        else {
            this.createPlanBlocksDraggableItems(true);
        }
        this.isLoading = false;
        this.$nextTick(() => {
            if (this.planCopy.teachers && this.planCopy.teachers.length) {
                this.selectedTeachers = this.planCopy.teachers.map((teacher) => ({
                    value: teacher.user.id || '',
                    text: teacher.user.name || '',
                    permission: teacher.permission,
                }));
                this.teacherSelectInput.setDefaultValue(this.selectedTeachers, false);
            }
            this.$refs.teacherSelect.querySelections('');
            this.isInitialized = true;
        });
    }
    // #endregion
    // #region Event handlers
    addSubjects(subjects) {
        this.appendBlock({
            title: '',
            content: '',
            id: '',
            sort: this.draggableBlockItems.length - 1,
            type: 'plp',
            student_subjects: subjects,
        });
    }
    onAddCurriculumToDocument(selectedSubjects) {
        if (selectedSubjects && selectedSubjects.length) {
            this.addSubjects(selectedSubjects);
        }
        this.isCurriculumSelectDialogOpen = false;
    }
    onReOrder(event) {
        const reorderedItems = sortBy(this.draggableBlockItems, (item) => event.items.indexOf(item.id));
        this.draggableBlockItems = [...reorderedItems];
        this.planCopy.blocks = this.draggableBlockItems.map((item) => ({ ...item.block }));
    }
    onReset() {
        this.planCopy = new StudentDocument();
        this.isEditingStartDate = false;
        this.isEditingEndDate = false;
        this.isAddingStep = false;
        this.planStatuses = [];
        this.studentLvs = [];
        this.planTemplates = [];
        this.teacherModel = new Teacher();
        this.internalSelectedTeachers = [];
        this.currentStep = 1;
    }
    async onClose() {
        await this.debouncedAutosave.flush();
        this.isInitialized = false;
        this.onReset();
        this.$emit('close');
    }
    onRemoveTeacher(teacher) {
        this.internalSelectedTeachers = this.internalSelectedTeachers.filter((selectedTeacher) => selectedTeacher.value !== teacher.value);
        this.$refs.teacherSelect.removeSelected(teacher);
    }
    onCurrentStepChanged(value) {
        this.currentStep = value;
    }
    onShareWithAllTeachersEditableChanged(value) {
        if (value) {
            this.$set(this.planCopy, 'is_visible_for_teachers', false);
            this.clearSelectedTeachers();
        }
    }
    onShareWithAllTeachersVisibleChanged(value) {
        if (value) {
            this.$set(this.planCopy, 'is_editable_for_teachers', false);
            this.clearSelectedTeachers();
        }
    }
    clearSelectedTeachers() {
        const teacherSelect = this.$refs.teacherSelect;
        this.selectedTeachers.forEach((teacher) => teacherSelect?.removeSelected(teacher));
        this.selectedTeachers = [];
    }
    // #endregion
    // #region Class methods
    getIsPlp(item) {
        return item.block.type === 'plp';
    }
    openCurriculumSelectDialog() {
        this.isCurriculumSelectDialogOpen = true;
    }
    createPlanBlocksDraggableItems(isExistingBlock = false) {
        if (this.planCopy && this.planCopy.blocks && this.planCopy.blocks.length) {
            this.planCopy.blocks.forEach((block) => this.appendBlock(block, isExistingBlock));
        }
    }
    cancelDebouncedPayload() {
        this.debouncedAutosave.cancel();
    }
    fillTemplates() {
        const foundTemplates = this.planTemplates.find((template) => template.id === (this.selectedTemplate && this.selectedTemplate.id));
        if (foundTemplates && foundTemplates.blocks) {
            this.draggableBlockItems = [];
            this.planCopy.blocks = [];
            foundTemplates.blocks.forEach((template) => this.appendBlock(template));
        }
    }
    appendBlockByType(type = 'text') {
        const newBlock = this.getEmptyStudentBlock(type);
        this.appendBlock(newBlock);
    }
    appendBlock(block, isExistingBlock = false) {
        this.isAddingStep = true;
        if (!this.planCopy.blocks) {
            this.planCopy.blocks = [];
        }
        const newBlock = block || this.getEmptyStudentBlock();
        const draggableStudentDocumentBlock = this.transformToDraggableItem(newBlock);
        this.draggableBlockItems.push(draggableStudentDocumentBlock);
        if (!isExistingBlock) {
            this.planCopy.blocks.push(newBlock);
        }
        this.isAddingStep = false;
    }
    getEmptyStudentBlock(type = 'text') {
        this.blockCounter++;
        return {
            content: '',
            title: type === 'simple-text' ? '' : '',
            id: `block-${Date.now()}-${this.blockCounter}-${Math.random().toString(36).substr(2, 9)}`,
            sort: 0,
            type,
        };
    }
    transformToDraggableItem(block) {
        return {
            id: block.id || `block-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            block,
        };
    }
    onRemoveObjective(draggableItem) {
        this.openConfirmDeleteDialog(draggableItem);
    }
    openConfirmDeleteDialog(draggableItem) {
        this.$store.dispatch('openDialog', this.removeObjectiveDialogOptions(draggableItem));
    }
    removeObjectiveDialogOptions(draggableItem) {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('scoollinks.dialog.delete.text').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        this.removeObjective(draggableItem);
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    removeObjective(draggableItem) {
        this.isAddingStep = true;
        if (!this.planCopy.blocks) {
            return;
        }
        const itemIndex = this.planCopy.blocks.findIndex((item) => draggableItem.block.id === item.id);
        if (this.draggableBlockItems) {
            this.draggableBlockItems = this.draggableBlockItems.filter((item) => item.id !== draggableItem.id);
        }
        if (itemIndex > -1) {
            this.planCopy.blocks.splice(itemIndex, 1);
        }
        this.isAddingStep = false;
    }
    formatBlocksPayload() {
        const blocksPayload = [];
        if (this.planCopy.blocks) {
            this.planCopy.blocks.forEach((block) => {
                if (block.type === 'plp') {
                    blocksPayload.push({
                        type: block.type,
                        student_subjects: block.student_subjects
                            ? block.student_subjects.map((block) => (block.id ? block.id : ''))
                            : [],
                        sort: block.sort,
                    });
                }
                else if (block.type === 'simple-text') {
                    blocksPayload.push({
                        content: block.content,
                        sort: block.sort,
                        type: block.type,
                    });
                }
                else {
                    blocksPayload.push({
                        title: block.title,
                        content: block.content,
                        sort: block.sort,
                        type: block.type,
                    });
                }
            });
        }
        return blocksPayload;
    }
    generatePlanCreatePayload(isPublish = false) {
        return generatePlanPayload({
            plan: this.planCopy,
            blocks: this.formatBlocksPayload(),
            documentableType: this.documentableType,
            entityId: this.entity.id || '',
            entityFieldName: this.entityType === DocumentEntityType.GROUP ? 'group_id' : 'project_id',
            selectedTeachers: this.selectedTeachers,
            isPublish,
            id: this.savedDocumentId,
        });
    }
    reset() {
        this.cancelDebouncedPayload();
        this.isInitialized = false;
        this.isSaving = false;
        this.savedDocumentId = undefined;
        this.currentStep = 1;
        this.isLoading = false;
        this.isLoadingPlanStatuses = false;
        this.isLoadingPlanTemplates = false;
        this.isLoadingUserCurriculum = false;
        this.isLoadingLvs = false;
        this.isEditingStartDate = false;
        this.isEditingEndDate = false;
        this.isAddingStep = false;
        this.planCopy = new StudentDocument();
        this.draggableBlockItems = [];
        this.planStatuses = [];
        this.studentLvs = [];
        this.planTemplates = [];
        this.teacherModel = new Teacher();
        this.internalSelectedTeachers = [];
        this.selectedTemplate = null;
        this.curriculum = new CurriculumModel();
        this.isLoading = true;
    }
    close() {
        this.reset();
        this.$emit('input', null);
    }
    // #endregion
    // #region Async methods (api calls only)
    async autosave() {
        if (!this.isInitialized || this.isSaving)
            return;
        await this.savePlan(false);
    }
    async createPlan(isPublish = false) {
        this.cancelDebouncedPayload();
        await this.savePlan(isPublish);
    }
    async savePlan(isPublish) {
        this.isSaving = true;
        if (isPublish) {
            this.isLoading = true;
        }
        try {
            const plan = await new StudentDocument().create(this.generatePlanCreatePayload(isPublish));
            if (!plan)
                return;
            this.savedDocumentId = plan.id || this.savedDocumentId;
            if (isPublish) {
                this.reset();
                this.$emit('submitted');
                return;
            }
            this.$emit('updated');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isSaving = false;
            if (isPublish) {
                this.isLoading = false;
            }
        }
    }
    async fetchPlanStatuses() {
        this.isLoadingPlanStatuses = true;
        this.planStatuses = await new StudentDocumentStatus().all();
        this.isLoadingPlanStatuses = false;
    }
    async fetchPlanTemplates() {
        this.isLoadingPlanTemplates = true;
        this.planTemplates = await new StudentDocumentTemplate()
            .include([StudentDocumentTemplateIncludes.BLOCKS])
            .filter({ documentable_type: this.documentableType })
            .all();
        this.isLoadingPlanTemplates = false;
    }
    async fetchUserLvs() {
        this.isLoadingLvs = true;
        new Lvs()
            .filter({ users: [this.$route.params.id] })
            .all()
            .then((result) => {
            if (Array.isArray(result)) {
                this.studentLvs = result.map((area) => {
                    return {
                        id: area.id,
                        name: area.name,
                        lvs_note: area.users[this.$route.params.id].notes,
                    };
                });
            }
            this.isLoadingLvs = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isLoadingLvs = false;
        });
    }
    async fetchCurriculum() {
        this.curriculum
            .current()
            .include(['children', 'subjects'])
            .first()
            .then((curriculum) => {
            this.curriculum = curriculum;
            const areas = this.curriculum.subjects || [];
            areas.forEach((area, index) => {
                this.curriculum.subjects[index] = this.curriculum.dataToModel(area, 'Subject');
                const topics = this.curriculum.subjects[index].children || [];
                topics.forEach((topic, i) => {
                    this.curriculum.subjects[index].children[i] = this.curriculum.dataToModel(topic, 'Subject');
                });
                topics.sort(sortByKey('name'));
                this.$set(this.curriculum.subjects[index], 'children', topics);
            });
            areas.sort(sortByKey('name'));
            this.$set(this.curriculum.subjects, 'subjects', areas);
            this.isLoadingUserCurriculum = false;
        });
    }
    // #endregion
    // #region Getters & Setters
    get isDisabled() {
        switch (this.currentStep) {
            case 1:
                return !this.planCopy.title;
            case 2:
                return false;
            default:
                return false;
        }
    }
    get dialogTitle() {
        return this.document ? this.$tc('Edit document') : this.$tc('Add document');
    }
    get canShowDeleteIcon() {
        return !!(this.draggableBlockItems && this.draggableBlockItems.length > 1);
    }
    get teacherSelectInput() {
        return this.$refs.teacherSelect;
    }
    get required() {
        return (value) => {
            return !!value || 'Field is required';
        };
    }
    get editorOptions() {
        return {
            placeholder: this.$t('student_plan.dialog.one.quill'),
        };
    }
    get selectedTeachers() {
        return this.internalSelectedTeachers;
    }
    set selectedTeachers(value) {
        this.internalSelectedTeachers = value.map((teacher) => {
            const oldTeacher = this.internalSelectedTeachers.find((selectedTeacher) => selectedTeacher.value === teacher.value);
            if (!('permission' in teacher)) {
                if (oldTeacher && 'permission' in oldTeacher) {
                    teacher.permission = oldTeacher.permission;
                }
                else {
                    teacher.permission = 'edit';
                }
            }
            return teacher;
        });
    }
    get teacherViewOptions() {
        return [
            { name: this.$tc('View and edit'), id: 'edit' },
            { name: this.$tc('View'), id: 'view' },
        ];
    }
    get isEditing() {
        return !!this.planCopy.id;
    }
    get dialogOptions() {
        return {
            steps: [
                { label: this.$tc('Basic information'), value: 1 },
                { label: this.$tc('Content'), value: 2 },
            ],
            title: this.dialogTitle,
            customButtons: [
                {
                    label: this.$tc('student_plan.dialog.save'),
                    action: async () => {
                        const isPublish = true;
                        await this.createPlan(isPublish);
                    },
                    visible: this.currentStep === 2,
                },
            ],
        };
    }
    get students() {
        if (this.entityType === DocumentEntityType.PROJECT) {
            return [];
        }
        const group = this.entity;
        if (!group.users) {
            return [];
        }
        return group.users.filter((user) => user.roles && user.roles.some((role) => role.id === RolesEnum.STUDENT));
    }
    get sortedStudents() {
        const sortedStudents = this.students.sort((a, b) => {
            if (!a.name || !b.name) {
                return 0; // If either name is missing, do not change order
            }
            return a.name.localeCompare(b.name);
        });
        return sortedStudents;
    }
    get documentableType() {
        return this.entityType === DocumentEntityType.GROUP
            ? DocumentableType.GROUP
            : DocumentableType.PROJECT;
    }
    // #endregion
    // #region @Watchers
    onPlanCopyChanged() {
        if (!this.isInitialized || this.isSaving)
            return;
        this.debouncedAutosave();
    }
    onSelectedTeachersChanged() {
        if (!this.isInitialized || this.isSaving)
            return;
        this.debouncedAutosave();
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], AddDocumentDialog.prototype, "entityType", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Object)
], AddDocumentDialog.prototype, "entity", void 0);
__decorate([
    Prop({ required: false, default: null }),
    __metadata("design:type", Object)
], AddDocumentDialog.prototype, "document", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], AddDocumentDialog.prototype, "canAddPlpItem", void 0);
__decorate([
    Watch('planCopy', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddDocumentDialog.prototype, "onPlanCopyChanged", null);
__decorate([
    Watch('internalSelectedTeachers', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddDocumentDialog.prototype, "onSelectedTeachersChanged", null);
AddDocumentDialog = __decorate([
    Component({
        components: {
            ActionDialogLayout,
            SelectFilter,
            PlanTemplateRow,
            AsyncSelect,
            Draggable,
            MediaComponent,
            SelectStudentLevelsDialog,
            CurriculumSelectDialog,
            AQuillEditor,
            AddCurriculumToDocumentDialog,
            Curriculum,
        },
    })
], AddDocumentDialog);
export default AddDocumentDialog;
// #region Enums
export var DocumentEntityType;
(function (DocumentEntityType) {
    DocumentEntityType["GROUP"] = "group";
    DocumentEntityType["PROJECT"] = "project";
})(DocumentEntityType || (DocumentEntityType = {}));
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
